export default __webpack_public_path__ + "static/media/login-visual5.c63b2a74.jpg";